export const useMe = createQuery('/users/me', {nullCollection: {scopes: []}})
